import { useSelector } from 'react-redux';
import Text from '../../../../../../shared/components/features/text/Text';
import NotAuthButton from '../../../../notAuthButton/NotAuthButton';
import virtualCampusLogoLogout from "../../../../../../assests/notAuth/virtualCampusLogoLogout.png";
import classes from './InfoFeaturesText.module.css';

const InfoFeaturesText = ({ infoFeaturesText, buttons }) => {

    const { texts } = useSelector(state => state.translate);    
    
    return (
        <div className={`${classes.InfoFeaturesText} ${classes.InfoSection}`}>
            <img className={classes.Logo} src={virtualCampusLogoLogout} alt='' loading="lazy" />
            <div className={classes.FeaturesTextWrapper}>
                {infoFeaturesText?.map(featuresText =>
                    <div className={classes.FeaturesText}>
                        <img className={classes.Img} src={featuresText.img} alt='' loading="lazy" />
                        <Text className={classes.Text}>{texts[featuresText.text]}</Text>
                    </div>
                )}
            </div>
            <div className={buttons?.length > 1 ? classes.ButtonsContainer : ''}>
                {buttons?.map((button, index) => <NotAuthButton key={index} text={button.text} link={button.link} icon={button.icon} className={classes.Btn} newTab={button.newTab} checkLogin={button.checkLogin} popup={button.popup} showLoadingPage={button.showLoadingPage} />)}
            </div>
    </div>
  );
};
export default InfoFeaturesText;
